export const firebaseErrors = {
  'auth/wrong-password': 'Current_Password_Incorrect',
  'auth/requires-recent-login': 'Sensitive_Operation_Warning'
}
